import { useState, useEffect, useMemo, useCallback } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import { useDisplayedData } from '../../table/tableHooks';
import { ScrollContainer } from 'foundations-components/transitional/components/ScrollContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PLAYLIST_HEIGHT = 250;
const LAZY_LOAD_DISTANCE = 40;
export const useLazyLoadedData = (page, data, loading, state) => {
  /**  loadedPages = {
   * 'state1': [[page1_result1, page1_result2, ...], [page2_result1, page2_result2, ...]]}
   * 'state2': [[page1_result1, page1_result2, ...], [page2_result1, page2_result2, ...]]}
   * */
  const [loadedPages, setLoadedPages] = useState({});
  const index = state ? JSON.stringify(state) : '';
  useEffect(() => {
    if (!loadedPages[index]) {
      setLoadedPages(prevLoadedPages => {
        return Object.assign({}, prevLoadedPages, {
          [index]: []
        });
      });
      return;
    }
    if (!data || loading || loadedPages[index][page - 1]) return;
    // accumulate previously loaded data
    setLoadedPages(prevLoadedPages => {
      return Object.assign({}, prevLoadedPages, {
        [index]: [...loadedPages[index], data]
      });
    });
  }, [loadedPages, page, data, loading, index]);
  return useMemo(() => {
    if (!loadedPages[index] || !loadedPages[index].length) return null;
    return loadedPages[index].flatMap(p => p.flat());
  }, [index, loadedPages]);
};
export const LazyLoadScrollContainer = ({
  loadNextPage,
  total,
  page,
  data,
  loading,
  render,
  loadMoreButton,
  state
}) => {
  const lazyLoadedData = useLazyLoadedData(page, data, loading, state);
  const displayedData = useDisplayedData(lazyLoadedData, {
    loading
  });
  const handleScroll = useCallback(e => {
    const {
      scrollTop,
      scrollHeight
    } = e.target;
    if (!loading && displayedData && displayedData.length < total && scrollTop + PLAYLIST_HEIGHT + LAZY_LOAD_DISTANCE >= scrollHeight) loadNextPage();
  }, [loadNextPage, displayedData, loading, total]);
  const hasMore = displayedData && displayedData.length < total;
  return !loadMoreButton ? /*#__PURE__*/_jsx(ScrollContainer, {
    gradientColor: "fill-surface-default",
    maxHeight: PLAYLIST_HEIGHT,
    onScroll: handleScroll,
    children: render(displayedData)
  }) : /*#__PURE__*/_jsxs(_Fragment, {
    children: [render(displayedData), hasMore && /*#__PURE__*/_jsx(Button, {
      onClick: loadNextPage,
      use: "unstyled",
      children: loadMoreButton
    })]
  });
};
export default LazyLoadScrollContainer;